import { createFileRoute } from '@tanstack/react-router';

import { normalizeCrmCustomerPaymentsReturnTo, PaymentDetailPage } from '@pages/payments';

export const Route = createFileRoute('/$locale/_authenticated/payments/$paymentId')({
  component: PaymentDetailRoute,
});

function PaymentDetailRoute() {
  const navigate = Route.useNavigate();
  const { locale, paymentId } = Route.useParams();
  const {
    detailReturn,
    detailReturnCustomerId,
    detailReturnGlobalUserProfileId,
    detailReturnProfileOriginCustomerId,
    detailReturnProfileOriginPaymentQ,
    detailReturnProfileOriginUserProfilePaymentsReturnTo,
    detailReturnQ,
    detailReturnRegistrationCustomerId,
    detailReturnRegistrationId,
    detailReturnRegistrationReturnTo,
    detailReturnUserProfilePaymentsReturnTo,
    detailTab,
  } = Route.useSearch();
  return (
    <PaymentDetailPage
      locale={locale}
      paymentId={paymentId}
      initialTab={detailTab}
      onBack={() => {
        if (detailReturn === 'user-profile' && detailReturnCustomerId) {
          const returnTo = normalizeCrmCustomerPaymentsReturnTo(
            detailReturnUserProfilePaymentsReturnTo,
            detailReturnCustomerId
          );
          if (returnTo !== undefined) {
            void navigate({ to: returnTo as never });
            return;
          }
          void navigate({
            to: '/$locale/crm/user-profiles/$userProfileId/payments',
            params: { userProfileId: detailReturnCustomerId, locale },
            search: { paymentQ: detailReturnQ },
          });
          return;
        }
        if (
          detailReturn === 'registration-profile' &&
          detailReturnRegistrationCustomerId &&
          detailReturnRegistrationId
        ) {
          void navigate({
            to: '/$locale/crm/user-profiles/$userProfileId/learning/registrations/$registrationId',
            params: {
              userProfileId: detailReturnRegistrationCustomerId,
              locale,
              registrationId: detailReturnRegistrationId,
            },
            search: {
              registrationProfileTab: 'payments',
              returnTo: detailReturnRegistrationReturnTo,
            },
          });
          return;
        }
        void navigate({
          to: '/$locale/payments',
          params: { locale },
          search: {
            profileOriginCustomerId: detailReturnProfileOriginCustomerId,
            profileOriginPaymentQ: detailReturnProfileOriginPaymentQ,
            profileOriginUserProfilePaymentsReturnTo:
              detailReturnProfileOriginUserProfilePaymentsReturnTo,
            q: detailReturnQ,
            tab: 'invoices',
            userProfileId: detailReturnGlobalUserProfileId,
          },
        });
      }}
    />
  );
}
